export const formatWalletName = (walletRaw) => {
  if (!walletRaw) return '';
  const walletWithoutUnwantedChars = walletRaw.replace(/\s|-/g, '');
  return walletWithoutUnwantedChars.toLowerCase();
};

export const getWalletLabel = (walletName) =>
  walletName.replace(/Wallet/g, ' Wallet');
